import React from 'react';
import { Breadcrumbs } from 'site-modules/shared/components/breadcrumbs/breadcrumbs';
import { InventoryEntities } from 'client/data/models/inventory';
import { getBreadcrumbs } from 'site-modules/shared/utils/inventory/vdp-utils';

export function VdpBreadcrumbs({ vinData = {} }) {
  const breadcrumbsData = getBreadcrumbs(vinData);
  return <Breadcrumbs data={breadcrumbsData} className="px-0" />;
}

VdpBreadcrumbs.propTypes = {
  vinData: InventoryEntities.InventoryVin,
};
